"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const forms_constants_1 = require("@Const/forms-constants");
const Dropdown_1 = __importDefault(require("@Components/Selectors/Dropdown"));
const default_options_1 = require("@Const/default-options");
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const get_value_form_1 = require("@App/helpers/get-value-form");
const contexts_1 = require("@App/contexts");
const form_is_valid_1 = require("@App/helpers/form-is-valid");
const support_1 = require("@App/api/routes/support");
const mobx_react_1 = require("mobx-react");
const rightsholder_1 = require("@App/api/routes/rightsholder/rightsholder");
const HelpDeskQuestionForm = () => {
    const { authStore, userStore, preloaderStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const getDefaultValidations = () => ({
        firstName: {
            required: true,
            maxLength: 200,
        },
        lastName: {
            required: true,
            maxLength: 200,
        },
        email: {
            required: true,
            isEmail: true,
            maxLength: 2000,
        },
        relatedTopRightsholder: {
            required: authStore.isLoggedIn ? authStore.isLoggedIn : undefined,
        },
        topic: {
            required: true,
        },
        subTopic: {
            required: true,
        },
        description: {
            required: true,
            maxLength: 2000,
        },
    });
    const isUserLoggedInWithUserInfo = authStore.isLoggedIn && !!userStore.userInfo;
    const getDefaultHelpFormData = () => {
        const userInfo = userStore.userInfo;
        return {
            firstName: isUserLoggedInWithUserInfo ? userInfo.firstName : '',
            lastName: isUserLoggedInWithUserInfo ? userInfo.lastName : '',
            email: isUserLoggedInWithUserInfo ? userInfo.email : '',
            relatedTopRightsholder: '',
            topic: '',
            subTopic: '',
            description: '',
        };
    };
    const getRightsHolderOptionList = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const rightsholders = yield (0, rightsholder_1.getRelatedRightsholders)();
        setRightsholderOptions((_b = (_a = rightsholders.data) === null || _a === void 0 ? void 0 : _a.map((title, index) => ({
            id: index.toString(),
            label: title.name,
            value: title.name,
        }))) !== null && _b !== void 0 ? _b : []);
    });
    const [helpFormData, setHelpFormData] = (0, react_1.useState)(getDefaultHelpFormData());
    const [validations, setValidations] = (0, react_1.useState)(getDefaultValidations());
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    const [topic, setTopic] = (0, react_1.useState)();
    const [subTopic, setSubTopic] = (0, react_1.useState)();
    const [rightsholderOptions, setRightsholderOptions] = (0, react_1.useState)();
    const [filteredHelpSubTopicOptions, setFilteredHelpSubTopicOptions] = (0, react_1.useState)([]);
    const getValue = (value, id) => {
        const data = (0, get_value_form_1.getValueForm)(value, id, helpFormData, validations);
        setHelpFormData(Object.assign({}, data.formObject));
        setValidations(Object.assign({}, data.validationObject));
    };
    const getValueForTopic = (option) => {
        setTopic(option);
        // clear the subtopic dropdown when selecting a new top level topic
        // setting subtopic to blank option, setting to undefined
        // did not clear the sub topic as expected
        const clearedSubTopic = { label: '', value: '', id: '' };
        setSubTopic(clearedSubTopic);
        setFilteredHelpSubTopicOptions(option ? option.subTopics : []);
        getValue(option.id, forms_constants_1.HELP_FORM.topic.id);
        getValue(clearedSubTopic.id, forms_constants_1.HELP_FORM.subTopic.id);
    };
    const getValueForSubTopic = (option) => {
        setSubTopic(option);
        getValue(option.id, forms_constants_1.HELP_FORM.subTopic.id);
    };
    const setDefaultHelpFormData = () => {
        setHelpFormData(getDefaultHelpFormData());
        setValidations(getDefaultValidations());
    };
    const onSubmitForm = () => {
        if (helpFormData && (0, form_is_valid_1.formIsValid)(helpFormData, validations)) {
            preloaderStore.openTransparentPreloader(true);
            (0, support_1.submitHelpForm)(helpFormData)
                .then(() => {
                setDefaultHelpFormData();
                preloaderStore.openTransparentPreloader(false);
                popupStore.setAlertData('Form Submitted', false);
            })
                .catch((error) => {
                preloaderStore.openTransparentPreloader(false);
                popupStore.setAlertData(error.message, true);
            });
        }
    };
    (0, react_1.useEffect)(() => {
        if (isUserLoggedInWithUserInfo) {
            getRightsHolderOptionList();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (rightsholderOptions && rightsholderOptions.length > 0) {
            helpFormData.relatedTopRightsholder = rightsholderOptions.length === 1 ? rightsholderOptions[0].value : '';
            setHelpFormData(Object.assign({}, helpFormData));
        }
        else {
            validations.relatedTopRightsholder.required = false;
            setValidations(Object.assign({}, validations));
        }
    }, [rightsholderOptions]);
    (0, react_1.useEffect)(() => {
        setIsValid((0, form_is_valid_1.formIsValid)(helpFormData, validations));
    }, [helpFormData, validations]);
    const { firstName, lastName, email, description } = helpFormData;
    return (react_1.default.createElement("form", { onSubmit: (e) => e.preventDefault(), className: 'form-section' },
        react_1.default.createElement("div", { className: 'contact-us-form-header' },
            react_1.default.createElement("img", { src: common_1.ICONS.email }),
            react_1.default.createElement("h5", null, "Submit a request"),
            react_1.default.createElement("span", null, "Typical reply time: within hours via email")),
        react_1.default.createElement("div", { className: 'fields-row-container' },
            react_1.default.createElement(InputText_1.default, { mainColor: true, id: forms_constants_1.HELP_FORM.firstName.id, label: forms_constants_1.HELP_FORM.firstName.label, value: firstName, onChange: getValue, errorMessage: validations.firstName.error, required: validations.firstName.required, disabled: isUserLoggedInWithUserInfo }),
            react_1.default.createElement(InputText_1.default, { mainColor: true, id: forms_constants_1.HELP_FORM.lastName.id, label: forms_constants_1.HELP_FORM.lastName.label, value: lastName, onChange: getValue, errorMessage: validations.lastName.error, required: validations.lastName.required, disabled: isUserLoggedInWithUserInfo }),
            react_1.default.createElement(InputText_1.default, { mainColor: true, id: forms_constants_1.HELP_FORM.email.id, label: forms_constants_1.HELP_FORM.email.label, value: email, onChange: getValue, errorMessage: validations.email.error, required: validations.email.required, disabled: isUserLoggedInWithUserInfo }),
            isUserLoggedInWithUserInfo && rightsholderOptions && rightsholderOptions.length ? (react_1.default.createElement(Dropdown_1.default, { options: rightsholderOptions, id: forms_constants_1.HELP_FORM.relatedTopRightsholder.id, label: forms_constants_1.HELP_FORM.relatedTopRightsholder.label, mainColor: true, defaultValue: rightsholderOptions.length === 1 ? rightsholderOptions[0] : null, onChange: getValue, required: validations.relatedTopRightsholder.required, isSearchable: true, "data-testid": 'related-rightsholder' })) : null,
            react_1.default.createElement(Dropdown_1.default, { options: default_options_1.helpTopicOptions, id: forms_constants_1.HELP_FORM.topic.id, label: forms_constants_1.HELP_FORM.topic.label, selectedValue: topic, mainColor: true, onSelect: getValueForTopic, required: validations.topic.required, isSearchable: true }),
            react_1.default.createElement(Dropdown_1.default, { options: filteredHelpSubTopicOptions, id: forms_constants_1.HELP_FORM.subTopic.id, label: forms_constants_1.HELP_FORM.subTopic.label, selectedValue: subTopic, mainColor: true, onSelect: getValueForSubTopic, required: validations.subTopic.required, isSearchable: true })),
        react_1.default.createElement("div", { className: 'fields-row-container' },
            react_1.default.createElement(InputText_1.default, { textareaType: true, mainColor: true, id: forms_constants_1.HELP_FORM.description.id, label: forms_constants_1.HELP_FORM.description.label, value: description, errorMessage: validations.description.error, required: validations.description.required, onChange: getValue })),
        react_1.default.createElement(Button_1.Button, { onClick: onSubmitForm, disabled: !isValid, mainColor: true, type: 'primary', icon: common_1.ICONS.arrow_forward }, "Submit")));
};
exports.default = (0, mobx_react_1.observer)(HelpDeskQuestionForm);
